'use strict';
angular.module('comitesRecevabilite.constants', []).constant('COMITE_STATUS', {
  SCHEDULED: 'SCHEDULED',
  PROGRAMMING: 'PROGRAMMING',
  PROGRAMMED: 'PROGRAMMED',
  VALIDATED: 'VALIDATED',
});
